import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  OnDestroy,
  Signal,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MessageService } from '../../../services/messages/messages.service';
import { LanguagePipe } from '../../../pipes/language/language.pipe';
import { filter, Subscription } from 'rxjs';
import { NavigationEnd, Router } from '@angular/router';
import {
  EMessageType,
  IMessage,
  IMessageWithText,
  isTemplateCode,
  TEMPLATE_CODES,
} from '@web/dtos';
import { TemplateStringPipe } from '../../../pipes/template-string/TemplateStringPipe.pipe';

@Component({
  selector: 'aw-snackbar',
  imports: [CommonModule, LanguagePipe, TemplateStringPipe],
  templateUrl: './snackbar.component.html',
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SnackbarComponent implements OnDestroy {
  protected readonly messageService: MessageService = inject(MessageService);
  protected readonly router: Router = inject(Router);
  private routeSub: Subscription;
  protected readonly EMessageType: typeof EMessageType = EMessageType;
  protected readonly currentMessages: Signal<IMessageWithText[]> = computed(
    () => {
      return this.messageService
        .messagesWithTexts()
        .filter((message: IMessage) => {
          return message.code;
        }) as IMessageWithText[];
    }
  );

  constructor() {
    this.routeSub = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(event => {
        this.messageService.clear();
      });
  }

  ngOnDestroy() {
    this.routeSub.unsubscribe();
  }

  removeMessage(msg: IMessage): void {
    this.messageService.remove(msg);
  }

  chooseTemplate(msg: IMessage): Record<string, string> {
    if (msg.code) {
      if (isTemplateCode(msg.code)) {
        const values: Record<string, string> = {};
        TEMPLATE_CODES[msg.code]!.forEach((key: string) => {
          values[key] = msg.params?.[key];
        });
        return values;
      }
      return { error: msg.params?.['error'] };
    }
    return {};
  }
}
